export default {
    prompt:"What color is the text?",
    field:"color",
    type:"style",
    colorPicker:true,
    default:"#000000ff"
}